import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=81a5621e"
import script from "../../services/teacher/change-password.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/change-password.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports